import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  gSettingForEdit: {
    id: undefined,
    title: "",
    day: "",
    min: "",
    hour: "",
    desc: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  gSettingId: undefined,
  showMakePopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const gSettingSlice = createSlice({
  name: "gSetting",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    gSettingListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    gSettingList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadgSettingForEdit: (state, action) => {
      const payload = action.payload;

      if (payload) {
        var tempObj = splitTime(payload.format);

        state.gSettingForEdit.hour = tempObj.hour;
        state.gSettingForEdit.day = tempObj.day;
        state.gSettingForEdit.min = tempObj.min;
      }

      state.gSettingForEdit.title = payload.title;
      state.gSettingForEdit.id = payload.id;
      state.gSettingForEdit.desc = payload.description;
    },
    loadgSettingMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
  },
});

function splitTime(input) {
  var split_time = input.split(":");
  var Days;
  var Hours;
  var Minutes;

  if (split_time.length > 0) {
    if (split_time[0]) {
      Days = split_time[0];
    } else Days = "00";
    if (split_time[1]) {
      Hours = split_time[1];
    } else Hours = "00";
    if (split_time[2]) {
      Minutes = split_time[2];
    } else Minutes = "00";
  }

  return { day: Days, hour: Hours, min: Minutes };
}
